import { createSelector } from 'reselect'
import { getCurrentMenuSelector } from 'modules/menu/selectors'

const hasMenuSelect = createSelector(
  getCurrentMenuSelector(),
  menuId => !!menuId
)

export default hasMenuSelect
